import { render, staticRenderFns } from "./GroupsTemplate.vue?vue&type=template&id=aed4d8ee&scoped=true"
import script from "./GroupsTemplate.vue?vue&type=script&lang=js"
export * from "./GroupsTemplate.vue?vue&type=script&lang=js"
import style0 from "./GroupsTemplate.vue?vue&type=style&index=0&id=aed4d8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed4d8ee",
  null
  
)

export default component.exports